module.exports = __webpack_public_path__ + "img/loriot-packet-forwarder-large-dark.884fb4ea.png";